import { Link, Paragraph } from '@vimeo/iris/typography';

export default function EmbedPresets() {
  return (
    <div>
      <Paragraph size="2">
        An <em>embed preset</em> is a reusable collection of settings for customizing the appearance
        and behavior of the embeddable Vimeo player. This feature is available to Vimeo Standard and
        Advanced members. For more information, see our{' '}
        <Link
          variant="minimal"
          href="https://vimeo.com/help/sso?redirect_to=https://help.vimeo.com/hc/en-us/articles/12426259745937-Customize-the-video-player"
        >
          Help Center
        </Link>
        .
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
